import useJoin from './useJoin';
import useLeave from './useLeave';

const useJoinLeave = (name: string | string[], joinFn?: (err?: any) => void, leaveFn?: (err?: any) => void) => {
	useJoin(name, joinFn);
	useLeave(name, leaveFn);
}

export default useJoinLeave;